// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiResult from "./LumiResult.res.js";
import * as LumiString from "./LumiString.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function map(aCodec, from, to) {
  return {
    toString: b => aCodec.toString(to(b)),
    fromString: s => Stdlib_Option.flatMap(aCodec.fromString(s), from)
  };
}

function iso(aCodec, from, to) {
  return {
    toString: b => aCodec.toString(to(b)),
    fromString: s => Stdlib_Option.map(aCodec.fromString(s), from)
  };
}

function string_toString(s) {
  return s;
}

function string_fromString(s) {
  return s;
}

let string = {
  toString: string_toString,
  fromString: string_fromString
};

function float(radix) {
  return {
    toString: x => x.toString(radix !== undefined ? Primitive_option.valFromOption(radix) : undefined),
    fromString: Stdlib_Float.fromString
  };
}

function int(radix) {
  return {
    toString: i => i.toString(radix),
    fromString: s => Stdlib_Int.fromString(s, radix)
  };
}

function bool_toString(b) {
  if (b) {
    return "true";
  } else {
    return "false";
  }
}

function bool_fromString(s) {
  switch (s) {
    case "false" :
      return false;
    case "true" :
      return true;
    default:
      return;
  }
}

let bool = {
  toString: bool_toString,
  fromString: bool_fromString
};

function option(codec) {
  let noneTag = "none";
  let someTag = "some-";
  return {
    toString: opt => Stdlib_Option.mapOr(opt, noneTag, v => someTag + codec.toString(v)),
    fromString: s => {
      if (s === noneTag) {
        return Primitive_option.some(undefined);
      } else if (s.startsWith(someTag)) {
        return Stdlib_Option.map(codec.fromString(s.slice(someTag.length)), v => Primitive_option.some(v));
      } else {
        return;
      }
    }
  };
}

function optionNull(param) {
  let fromString = param.fromString;
  let toString = param.toString;
  return {
    toString: opt => {
      if (opt !== undefined) {
        return toString(Primitive_option.valFromOption(opt));
      } else {
        return "";
      }
    },
    fromString: str => {
      if (str === "") {
        return Primitive_option.some(undefined);
      } else {
        return Stdlib_Option.map(fromString(str), x => Primitive_option.some(x));
      }
    }
  };
}

function jzon(codec) {
  return {
    toString: v => Jzon.encodeStringWith(v, codec),
    fromString: s => LumiResult.ok(Jzon.decodeStringWith(s, codec))
  };
}

let LumiJzonSumValueNotFound = /* @__PURE__ */Primitive_exceptions.create("StringCodec.LumiJzonSumValueNotFound");

function sumAsString(pairs) {
  return {
    toString: needle => {
      let s = Stdlib_Array.findMap(pairs, param => {
        if (Primitive_object.equal(param[0], needle)) {
          return param[1];
        }
      });
      if (s !== undefined) {
        return s;
      }
      throw {
        RE_EXN_ID: LumiJzonSumValueNotFound,
        Error: new Error()
      };
    },
    fromString: needle => Stdlib_Array.findMap(pairs, param => {
      if (param[1] === needle) {
        return Primitive_option.some(param[0]);
      }
    })
  };
}

function anySumAsString(values, modifyOpt) {
  let modify = modifyOpt !== undefined ? modifyOpt : s => s;
  return sumAsString(values.map(v => [
    v,
    modify(LumiString.anyToString(v))
  ]));
}

export {
  map,
  iso,
  string,
  float,
  int,
  bool,
  option,
  optionNull,
  jzon,
  LumiJzonSumValueNotFound,
  sumAsString,
  anySumAsString,
}
/* No side effect */
